import LoadableImage from "../LoadableImage";
import Navigation from "../Navigation";
import BackLink from "../BackLink";
import ForwardLink from "../ForwardLink";
import {useEffect} from "react";

function Page86() {
  useEffect(() => {
    document.title = "Маяк — Страница 85"
  }, []);

  return (
    <>
      <Navigation />

      <div className="NavigationLink-wrapper">
        <BackLink href="/page84" />
        <ForwardLink href="/page86" />
      </div>

      <p style={{ textAlign: "right" }}>85.</p>
      <p style={{ textAlign: "center" }}>
        МОЛОДОЙ<br/>
        Стоп.
      </p>
      <p style={{ textAlign: "center" }}>
        СТАРИК<br/>
        Боцман трясся...
      </p>
      <p style={{ textAlign: "center" }}>
        МОЛОДОЙ<br/>
        Заткнись, я сказал.
      </p>
      <p style={{ textAlign: "center" }}>
        СТАРИК<br/>
        ... его челюсти были сомкнуты крепче,<br/>
        чем якорный сгиб--
      </p>
      <p>МОЛОДОЙ взрывается:</p>
      <p style={{ textAlign: "center" }}>
        МОЛОДОЙ<br/>
        ЗАТКНИСЬ! Я же сказал тебе, что больше не могу<br/>
        слушать! Закрой рот!
      </p>
      <p style={{ textAlign: "center" }}>
        СТАРИК<br/>
        Опять ты меня в чем-то обвиняешь.<br/>
        Ты уже сказал, что поймал меня, черт возьми--
      </p>
      <p style={{ textAlign: "center" }}>
        МОЛОДОЙ<br/>
        Я устал слушать твои<br/>
        дурацкие байки и всякую чушь в духе<br/>
        Капитана Ахава -- ты звучишь как<br/>
        проклятая пародия. Отдаешь приказы<br/>
        и придираешься как старая<br/>
        дева-учительница... и... и...
      </p>
      <p style={{ display: "flex" }}>
        <div>
          <div style={{ textAlign: "center" }}>СТАРИК</div>
          <div style={{ textAlign: "center" }}>(самому себе)</div>
          Очередной припадок.
          <div style={{ textAlign: "center" }}>(молодому)</div>
          Ты выставляешь себя дураком.
        </div>
        <div style={{ marginLeft: "auto" }}>
          <div style={{ textAlign: "center" }}>МОЛОДОЙ (ПРОДОЛЖЕНИЕ)</div>
          в то же время превращая эту<br/>
          станцию в дьявольскую<br/>
          яму.
        </div>
      </p>
      <p style={{ textAlign: "center" }}>
        МОЛОДОЙ (ПРОДОЛЖЕНИЕ)<br/>
        Ну, это все херня, твоя нога<br/>
        и твоя морская жизнь, все это.<br/>
        И мне это надоело. Если я услышу еще одно<br/>
        дерьмовое слово из твоих<br/>
        грязных, гнилых зубов, вонючего старого<br/>
        рта--
      </p>
      <p style={{ textAlign: "center" }}>
        СТАРИК<br/>
        Д--
      </p>
      <p style={{ textAlign: "center" }}>
        МОЛОДОЙ<br/>
        Заткнись, черт возьми -- я<br/>
        еще не закончил.<br/>
        (ДАЛЕЕ)
      </p>
      <p style={{ textAlign: "right" }}>85.</p>

      <Navigation />
      
      <div className="NavigationLink-wrapper">
        <BackLink href="/page84" />
        <ForwardLink href="/page86" />
      </div>

      <LoadableImage
        src="https://res.cloudinary.com/linuxmachinecloud/image/upload/v1710717754/the-lighthouse-script/yyfb8iqrb7ftxgmzkg4j.jpg"
        alt="Иллюстрация"
      />
    </>
  );
}

export default Page86;
